<template>
  <ul class="social p-0 d-flex mt-4">
    <li class="social__item">
      <a
        href="https://vk.com/ymxhy2tiawdjb2nr"
        target="_blank"
        rel="nofollow noopener"
        class="social__link d-flex"
        style="background-color: rgb(69, 102, 142);"
        ><img src="@/assets/vk.svg" alt="vk" class="social__icon m-auto"
      /></a>
    </li>
    <li class="social__item">
      <a
        href="https://teleg.one/YmxhY2tiaWdjb2Nr"
        target="_blank"
        rel="nofollow noopener"
        class="social__link d-flex"
        style="background-color: rgb(0, 136, 204);"
        ><img src="@/assets/telegram.svg" alt="tg" class="social__icon m-auto"
      /></a>
    </li>
    <li class="social__item">
      <a
        href="https://wa.me/79105015831"
        target="_blank"
        rel="nofollow noopener"
        class="social__link d-flex"
        style="background-color: rgb(7, 94, 84);"
        ><img src="@/assets/whatsapp.svg" alt="wh" class="social__icon m-auto"
      /></a>
    </li>
    <li class="social__item">
      <a
        href="https://github.com/alexandergurkovdev"
        target="_blank"
        rel="nofollow noopener"
        class="social__link d-flex"
        style="background-color: rgb(51, 51, 51);"
        ><img src="@/assets/github.svg" alt="git" class="social__icon m-auto"
      /></a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Social'
};
</script>

<style lang="scss" scoped>
.social {
  &__item {
    margin-right: 15px;
    list-style: none;
  }
  &__link {
    width: 40px;
    height: 40px;
    transition: 0.3s transform ease-in-out;
    &:hover {
      transform: translateY(-1px);
    }
  }
  &__icon {
    width: 20px;
    height: 20px;
  }
}
</style>
